const getters = {
  userInfo: (state) => state.permission.userInfo,
  isLogin: (state) => state.permission.isLogin,
  role: (state) => state.permission.role,
  menus: (state) => state.permission.menus,
  allMenusList: (state) => state.permission.allMenusList,
  allMenusTree: (state) => state.permission.allMenusTree,
  activeMenu: (state) => state.permission.activeMenu,
  site: (state) => state.permission.siteInfo,
  activeMenuId: (state) => state.permission.activeMenu.id,
  curDetailTitle: (state) => state.permission.curDetailTitle,
  bottomNavList: (state) => state.permission.bottomNavList,
};

export default getters;
